import { z } from 'zod';

import type { IdCompanyDto } from '@/services/ws-permissions/src/main/resources/rest-api';
import type { IdAdMediumDto } from '@/services/ws-print/src/main/resources/rest-api';
import type { CampaignPositionStatus } from '@/services/ws-print-operations/src/main/resources/rest-api';
import type { DateRangeType } from '@/js/libs/ui/src/V2';

import type { Option } from 'src/types.ts';

export interface PrintOperationsRouteParams {
  status: CampaignPositionStatus;
}

export type ExtendedCampaignPositionStatus = CampaignPositionStatus | 'PHYSICAL_PROOFS' | 'EXTRACTED_LABELS';

const PrintSearchKeyZod = z.enum(['activeTabId']);
export const PrintSearchKey = PrintSearchKeyZod.Enum;
export type PrintSearchKey = (typeof PrintSearchKey)[keyof typeof PrintSearchKey];

export const PrintSearchParams = z.object({
  [PrintSearchKey.activeTabId]: z.custom<ExtendedCampaignPositionStatus>().optional(),
});
export type PrintSearchParams = z.infer<typeof PrintSearchParams>;

export type FiltersState = {
  search: string;
  dateRange: DateRangeType | null;
  adMediumId: Option<IdAdMediumDto> | null;
  companyId: Option<IdCompanyDto> | null;
};
